import api from '../api';

export default {
    async getDataLesson(accessToken, idCourse, idLesson) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/lesson/${idCourse}/${idLesson}`,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar cursos da lesson:', error);
                throw error;
        }
    },
    async getDataLastLesson(accessToken, id) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/course/lastlesson/${id}`,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar ultima lesson:', error);
                throw error;
        }
    },
    async updateProgressLesson(accessToken, id) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/lesson/read/${id}`,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar o progresso da lesson:', error);
                throw error;
        }
    },
    async getLatestCourse(accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/course/latest`,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar último curso:', error);
            throw error;
        }
    }
}

